import { eligibleDependentEntriesSelector } from 'apps/formsCreationKit/store/selectors/entities'
import {
    StandardAdvancedSettings,
    AdvancedSettingsPanel
} from 'apps/studio/components/settings/fields/Base/advanced'
import { useSelector } from 'react-redux'
import { blackListedTypesForFollowUpName } from 'apps/builder/lib/utils'

const FollowUpName = {
  label: 'Follow-Up Name',
  settingType: 'sheetEntrySelect',
  property: 'summary_entry',
  nestedValue: 'guid',
  tooltip: 'Choose the field to display as the follow-up name.',
  dynamicChoices: () => {
    return useSelector(eligibleDependentEntriesSelector).reduce(
      (screens, { sheet, entries, screenLabel }) => {
        const validEntries = entries.reduce((acc, entry) => {
          const { type, label, placeholder, guid } = entry
          if (!blackListedTypesForFollowUpName.includes(type)) {
            acc.push({
              value: guid,
              label: label ? label : placeholder,
              type,
              sheet,
            })
          }
          return acc
        }, [])

        if (validEntries.length) {
          screens.push({
            label: screenLabel,
            options: validEntries,
          })
        }
        return screens
    }, [])
  },
}

export const PassFailAdvancedPanel = AdvancedSettingsPanel([
  FollowUpName,
  ...StandardAdvancedSettings
])
